import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_117_4056)">
      <path
        d="M8 15.25C4.00223 15.25 0.75 11.9978 0.75 8C0.75 4.00223 4.00223 0.75 8 0.75C11.9978 0.75 15.25 4.00223 15.25 8C15.25 11.9978 11.9978 15.25 8 15.25ZM8 1.95833C4.66863 1.95833 1.95833 4.66863 1.95833 8C1.95833 11.3314 4.66863 14.0417 8 14.0417C11.3314 14.0417 14.0417 11.3314 14.0417 8C14.0417 4.66863 11.3314 1.95833 8 1.95833ZM11.0208 8C11.0208 7.6659 10.7508 7.39583 10.4167 7.39583H8.60417V4.375C8.60417 4.0409 8.3335 3.77083 8 3.77083C7.6665 3.77083 7.39583 4.0409 7.39583 4.375V8C7.39583 8.3341 7.6665 8.60417 8 8.60417H10.4167C10.7508 8.60417 11.0208 8.3341 11.0208 8Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_117_4056">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const TimeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default TimeIcon;
